<template>
  <div class="form">
    <div v-show="!loading">
      <h1>{{ $lang("體能挑戰日") }}</h1>
      <!-- <b-form-group>
            <b-form-radio-group v-model="selected" class="py-3 px-3 text-light bg-info" @change="selectedChange">
                <b-form-radio value="individual" :disabled="is_perview">
                    <span class="text-light">{{ $lang("個人報名表") }}</span>
                </b-form-radio>
                <b-form-radio value="team" :disabled="is_perview">
                    <span class="text-light">{{ $lang("隊際報名表") }}</span>
                </b-form-radio>
            </b-form-radio-group>
        </b-form-group> -->
      <b-form-group class="py-3 px-3 text-light bg-info">
        <b-row v-if="is_group == 'individual' || isType == 'individual'">
          <span class="text-light">{{ $lang("TEXT_INDIVIDUAL_APPLY") }}</span>
        </b-row>
        <b-row v-if="is_group == 'team' || isType == 'team'">
          <span class="text-light">{{ $lang("TEXT_TEAM_APPLY") }}</span>
        </b-row>
      </b-form-group>
      <b-form
        ref="form1"
        @submit="onSubmit"
        v-show="is_group == 'team' || isType == 'team'"
      >
        <div class="form-header">
          <div class="checkbox-group">
            <b-form-checkbox v-model="form.isAgree1" :disabled="is_perview">
              <span class="lbl"> {{ $lang("TEXT_ACCEPT_SELF_6") }}</span>
            </b-form-checkbox>
            <b-form-checkbox v-model="form.isAgree2" :disabled="is_perview">
              <span class="lbl">
                {{
                  $lang(
                    "由本人代表聲明於1966年至2003年出生的隊友(另交聲明書者除外)的健康狀況，並確認已得到該些隊友的同意，聲明其健康及體能良好，適宜參加上述活動"
                  )
                }}</span
              >
            </b-form-checkbox>
            <b-form-checkbox v-model="isVaccination" :disabled="is_perview">
              <span style="padding-top: 2px" class="lbl">{{
                $lang(
                  "我已知悉於比賽當天必須完成接種兩劑新冠疫苗滿14天或持有效的核酸檢測陰性報告"
                )
              }}</span>
            </b-form-checkbox>
            <!--    <p class="checkbox-attention-text">
                        <span>{{ $lang("TEXT_ATTENTION_CHECKBOX") }}</span>å
                    </p> -->
            <!-- <template>
              <p>
                <span
                  >{{ $lang("ATTENTION_FOUR_FIRST") }}(<a
                    :href="url"
                    target="_blank"
                    >{{ $lang("TITLE_HEALTH_DOWN_URL") }}</a
                  >){{ $lang("ATTENTION_FOUR_LAST") }}</span
                >
              </p>
            </template> -->
            <!-- <div  class="upload-check" :disabled="is_perview">
              <InputFile
                accept=".jpg, .png, .gif, .pdf"
                v-model="form.healthFile"
                :word="$lang('BTN_UPLOAD_FILE')"
                :disabled="is_perview"
              />
              <span>*{{ $lang("TEXT_ACCEPT_SELF_4") }}</span>
            </div> -->
          </div>
        </div>
        <b-form-group :label="$lang('FIELD_CHILD_GROUP_NAME')">
          <b-form-input
            type="text"
            v-model="form.teamName"
            v-validate="'required'"
            name="teamName"
            :class="errors.has('teamName') && 'is-invalid'"
            :disabled="is_perview"
          ></b-form-input>
          <b-form-invalid-feedback :state="errors.has('teamName')">
            {{ errors.first("teamName") }}
          </b-form-invalid-feedback>
        </b-form-group>
        <template v-for="(item, index) in form.teamMembers">
          <div :key="item.key">
            <p class="text-left" v-if="index == 0">{{ $lang("隊長") }}</p>
            <p class="text-left" v-if="index > 0">{{ $lang("隊員") }}</p>
            <summer-form
              :isIndividual="false"
              :requiredType="requiredType"
              :value.sync="item"
              :rules="rules_adult"
              class="dashed"
              ref="form-item"
              :disabled="is_perview"
            >
            </summer-form>
          </div>
        </template>
        <div class="form-footer">
          <div>
            <template v-if="!is_perview">
              <button
                type="submit"
                class="btn btn-primary btn-submit save"
                @click="save"
                :disabled="isDisable"
              >
                {{ $lang("TEXT_SAVE") }}
              </button>
              <button
                type="submit"
                class="btn btn-primary btn-submit save"
                @click="submitForm"
                :disabled="isDisable"
              >
                {{ $lang("提交") }}
              </button>
            </template>
            <p v-html="$lang('TITLE_FORM_TIP')">
            </p>
          </div>
        </div>
      </b-form>

      <b-form
        ref="form2"
        @submit="onSubmit2"
        v-show="is_group == 'individual' || isType == 'individual'"
      >
        <div class="form-header">
          <div class="checkbox-group">
            <b-form-checkbox
              v-if="isAdultnew"
              v-model="form2.isAgree1"
              :disabled="is_perview"
            >
              <span style="padding-top: 2px" class="lbl">{{
                $lang("TEXT_ACCEPT_SELF_6")
              }}</span>
            </b-form-checkbox>
            <b-form-checkbox v-model="isVaccination" :disabled="is_perview">
              <span style="padding-top: 2px" class="lbl">{{
                $lang(
                  "我已知悉於比賽當天必須完成接種兩劑新冠疫苗滿14天或持有效的核酸檢測陰性報告"
                )
              }}</span>
            </b-form-checkbox>
            <template v-if="!isAdultnew">
              <p class="checkbox-attention-text">
                <span>{{ $lang("TEXT_ATTENTION_CHECKBOX") }}</span>
              </p>
              <template>
                <p>
                  <span
                    >{{ $lang("ATTENTION_FOUR_FIRST") }}(<a
                      :href="url"
                      target="_blank"
                      >{{ $lang("TITLE_HEALTH_DOWN_URL") }}</a
                    >){{ $lang("ATTENTION_FOUR_LAST") }}</span
                  >
                </p>
              </template>
              <div class="upload-check" :disabled="is_perview">
                <InputFile
                  accept=".jpg, .png, .gif, .pdf"
                  v-model="form2.healthFile"
                  :word="$lang('BTN_UPLOAD_FILE')"
                  :disabled="is_perview"
                />
                <span>*{{ $lang("TEXT_ACCEPT_SELF_4") }}</span>
              </div>
            </template>
          </div>
        </div>
        <summer-form
          :isIndividual="true"
          :requiredType="requiredType"
          :value.sync="form2.teamMembers[0]"
          :rules="rules"
          ref="form2-item"
          class="dashed"
          :disabled="is_perview"
        ></summer-form>
        <b-row style="justify-content: center">
          <b-col style="padding-left: 15px" md="12">
            <p>{{ $lang("TEXT_COMPETITION_CATEGORY") }}</p>
          </b-col>
          <b-col md="10">
            <b-row>
              <b-col md="6">
                <b-form-group
                  :label="$lang('TEXT_INDIVIDUAL_PHYSICAL_CHALLENGE')"
                >
                  <template v-if="form2.isChild">
                    <!-- <b-form-checkbox-group v-model="form2.teenager" name="flavour-2" :disabled="disabled ? (is_perview || form2.individual) : (form2.individual && !disabled)"> -->
                    <b-form-checkbox-group
                      v-model="form2.teenager"
                      name="flavour-2"
                      :disabled="disabled ? is_perview || !is_edit : disabled"
                    >
                      <b-form-text text-variant="danger">{{
                        $lang("TEXT_JUNIOR_GROUP")
                      }}</b-form-text>
                      <b-form-checkbox value="runBack">{{
                        $lang("TEXT_RUNBACK")
                      }}</b-form-checkbox
                      ><br />
                      <b-form-checkbox value="bobbiJump">{{
                        $lang("TEXT_BOBBIJUMP")
                      }}</b-form-checkbox
                      ><br />
                      <b-form-checkbox value="JumpBox">{{
                        $lang("TEXT_JUMPBOX")
                      }}</b-form-checkbox
                      ><br />
                      <!-- <b-form-checkbox value="feetJump">{{
                        $lang("TEXT_FEETJUMP")
                      }}</b-form-checkbox
                      ><br />
                      <b-form-checkbox value="plankClapHands">{{
                        $lang("TEXT_PLANKCLAPHANDS")
                      }}</b-form-checkbox
                      ><br /> -->
                    </b-form-checkbox-group>
                  </template>
                  <template v-else>
                    <!-- <b-form-checkbox-group v-model="form2.public" name="flavour-2" :disabled="disabled ? (is_perview || form2.individual) : (form2.individual && !disabled)"> -->
                    <b-form-checkbox-group
                      v-model="form2.public"
                      name="flavour-2"
                      :disabled="disabled ? is_perview || !is_edit : disabled"
                    >
                      <b-form-text text-variant="danger">{{
                        $lang("TEXT_ADULT_GROUP")
                      }}</b-form-text>
                      <b-form-checkbox value="plateSupport">{{
                        $lang("TEXT_PLATESUPPORT")
                      }}</b-form-checkbox
                      ><br />
                      <b-form-checkbox value="PullUp">{{
                        $lang("TEXT_PULLUP")
                      }}</b-form-checkbox
                      ><br />
                      <b-form-checkbox value="bobbiJump">{{
                        $lang("TEXT_BOBBIJUMP")
                      }}</b-form-checkbox
                      ><br />
                      <b-form-checkbox value="runBack">{{
                        $lang("TEXT_RUNBACK")
                      }}</b-form-checkbox
                      ><br />
                    </b-form-checkbox-group>
                  </template>
                </b-form-group>
              </b-col>
              <b-col md="6" v-if="!form2.isChild">
                <b-form-group :label="$lang('TEXT_MIXED_PHYSICAL_CHALLENGE')">
                  <!-- <b-form-checkbox v-model="form2.individual" name="flavour-2" :disabled="disabled ? (form2.isChild || form2.public.length > 0) : ((form2.isChild || form2.public.length > 0) && !disabled )"> -->
                  <b-form-checkbox
                    v-model="form2.individual"
                    name="flavour-2"
                    :disabled="
                      disabled
                        ? is_perview || ispersion
                        : ispersion && !disabled
                    "
                  >
                    <!-- 個人 -->
                    {{ $lang("FIELD_SINGLE")
                    }}<b-form-text :inline="true" text-variant="danger">{{
                      $lang("TEXT_MIXED_LIMIT")
                    }}</b-form-text>
                  </b-form-checkbox>
                  <ul>
                    <!-- <li>波比跳:20次</li>
                                    <li>開合跳:20次</li>
                                    <li>掌上壓:20次</li>
                                    <li>雙手垂直向下拋接球:20次</li>
                                    <li>折返跑:20次</li> -->
                    <li>{{ $lang("TEXT_TANLI_30") }}</li>
                    <li>{{ $lang("TEXT_BOBBIJUMP_20") }}</li>
                    <li>{{ $lang("TEXT_TURN_TIRE") }}</li>
                    <li>{{ $lang("TEXT_RUNBACK_30_2") }}</li>
                  </ul>
                </b-form-group>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <div class="form-footer">
          <div>
            <template v-if="!is_perview">
              <button
                type="submit"
                class="btn btn-primary btn-submit save"
                @click="save"
                :disabled="isDisable"
              >
                {{ $lang("TEXT_SAVE") }}
              </button>
              <button
                type="submit"
                class="btn btn-primary btn-submit save"
                @click="submitForm"
                :disabled="isDisable"
              >
                {{ $lang("提交") }}
              </button>
            </template>
            <p v-html="$lang('TITLE_FORM_TIP')">
            </p>
          </div>
        </div>
      </b-form>
    </div>
    <div class="spinner" v-show="loading">
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </div>
  </div>
</template>

<script>
import { $apis } from "@/helper";
import SummerForm from "@/components/SummerForm";
import InputFile from "@/components/InputFile";
import { ValidationObserver } from "vee-validate";
import utils from "@/helper/utils";

export default {
  props: {
    mode: {
      type: String,
      default: "new",
    },
  },
  components: {
    InputFile,
    SummerForm,
    ValidationObserver,
  },
  data() {
    return {
      loading: false,
      index: 4,
      isVaccination: false,
      isAdultnew: null,
      requiredType: false,
      status: "",
      // selected: "individual",
      isType: "",
      isDisable: false,
      rules: {
        birth: {
          conforming_age: [1967, 2009],
        },
        // phone: {
        //     mobile: ''
        // }
      },
      rules_adult: {
        birth: {
          team_conforming_age: [1967, 2004],
        },
      },
      // form: {
      //     id: null,
      //     healthFile: "",
      //     isAgree1: null,
      //     groupType: "team",
      //     teamName: null,
      //     teamMembers: [{
      //             phone: "66666666",
      //             isTeamCaptain: true,
      //             lastName: "ff",
      //             firstName: "dd",
      //             bornAt: "1996/12/18",
      //             idNumber: "51233579",
      //             gender: "M",
      //             idType: 1
      //         },
      //         {
      //             phone: "66666666",
      //             lastName: "ff",
      //             firstName: "dd",
      //             bornAt: "1996/12/18",
      //             idNumber: "51233589",
      //             gender: "M",
      //             idType: 1
      //         },
      //         {
      //             phone: "66666666",
      //             lastName: "ff",
      //             firstName: "dd",
      //             bornAt: "1996/12/18",
      //             idNumber: "51233599",
      //             gender: "M",
      //             idType: 1
      //         }
      //     ]
      // },
      form: {
        isAgree3: this.isVaccination,
        id: null,
        healthFile: "",
        // isAgree1: null,
        isAgree1: null,
        isAgree2: null,
        groupType: "team",
        teamName: null,
        teamMembers: [
          {
            phone: "",
            isTeamCaptain: true,
            lastName: "",
            firstName: "",
            bornAt: "",
            idNumber: "",
            gender: "M",
            idType: 1,
            firstVaccination: "",
            secondVaccination: "",
          },
          {
            phone: "",
            lastName: "",
            firstName: "",
            bornAt: "",
            idNumber: "",
            gender: "M",
            idType: 1,
            firstVaccination: "",
            secondVaccination: "",
          },
          {
            phone: "",
            lastName: "",
            firstName: "",
            bornAt: "",
            idNumber: "",
            gender: "",
            idType: 1,
            firstVaccination: "",
            secondVaccination: "",
          },
        ],
      },
      ispersion: false,
      form2: {
        isAgree3: this.isVaccination,
        id: null,
        groupType: "individual",
        healthFile: null,
        isAgree1: null,
        // isAgree1: true,
        isChild: false,
        teamMembers: [
          {
            phone: null,
            lastName: null,
            firstName: null,
            bornAt: "",
            idNumber: null,
            gender: "M",
            idType: 1,
            firstVaccination: "",
            secondVaccination: "",
          },
        ],
        mixedChallenge: [],
        public: [],
        teenager: [],
        individual: false,
      },
      // form2: {
      //     id: null,
      //     groupType: "individual",
      //     healthFile: null,
      //     isAgree1: null,
      //     teamMembers: [{
      //         phone: "66666666",
      //         lastName: "ff",
      //         firstName: "dd",
      //         bornAt: "1996/12/18",
      //         idNumber: "51233569",
      //         gender: "M",
      //         idType: 1
      //     }],
      //     mixedChallenge: [],
      //     individual: true
      // }
    };
  },
  methods: {
    save() {
      this.requiredType = false;
      this.status = "draft";
      // console.log(this.form2.mixedChallenge.length);
    },
    submitForm() {
      this.requiredType = true;
      this.status = "approval";
    },
    async onSubmit(evt) {
      evt.preventDefault();
      var form = {
        ...this.form,
        status: this.status,
        teamMembers: this.uploadMembers(this.form.teamMembers),
      };
      if (this.status === "draft") {
        this.recordUpdate(form);
        this.errorScoll();
      } else {
        let hasfemale = false;
        let teamMembers = form.teamMembers;
        teamMembers.forEach((item, index) => {
          const gender = item.gender;
          if (gender === "F") {
            hasfemale = true;
          }
        });
        if (!hasfemale) {
          this.notification.warning(this.$lang("至少有一名為女性"));
          return false;
        }
        // var noChild = this.noChild(form);
        var promise_list = await this.$refs["form-item"].map((item) =>
          item.onSubmit()
        );
        // var result = promise_list.every(item => item);
        // await this.$validator.validateAll("form1");
        // this.errorScoll();
        this.$validator.validateAll("form1").then((validate) => {
          Promise.all(promise_list).then((list) => {
            var result = list.every((item) => item);
            this.errorScoll();

            // if (noChild) {
            //     if (form.isAgree1 && !form.healthFile) {
            //         this.notification.warning(this.$lang("TEXT_WARNING_3"));
            //     } else if (form.isAgree1 && result) {
            //         this.recordUpdate(form);
            //         this.errorScoll();
            //     }
            // } else {
            //     if (form.isAgree1 && !form.healthFile) {
            //         this.notification.warning(this.$lang("TEXT_WARNING_1"));
            //     } else if (result) {
            //         this.recordUpdate(form);
            //         this.errorScoll();
            //     }
            // }

            // 不用判斷child
            this.$validator.validate("teamName").then((results) => {
              if (results) {
                if (form.isAgree1 && form.isAgree2 && this.isVaccination) {
                  if (result) {
                    this.recordUpdate(form);
                    this.errorScoll();
                  }
                } else {
                  this.notification.warning(this.$lang("必須作出聲明"));
                }
              } else {
                this.errorScoll();
              }
            });
          });
        });
      }

      // if (noChild) {
      //   if (form.isAgree1) {
      //     if (result) {
      //       this.recordUpdate(form);
      //       this.errorScoll();
      //     }
      //   } else {
      //     this.notification.warning(this.$lang("TEXT_WARNING_3"));
      //   }
      // } else {
      //   if (!form.isAgree1 && !form.healthFile) {
      //     this.notification.warning(this.$lang("TEXT_WARNING_1"));
      //   } else {
      //     if (result) {
      //       this.recordUpdate(form);
      //       this.errorScoll();
      //     }
      //   }
      // }

      // noChild
      //   ? form.isAgree1
      //     ? result && (this.recordUpdate(form), this.errorScoll())
      //     : this.notification.warning(this.$lang("TEXT_WARNING_3"))
      //   : !form.isAgree1 && !form.healthFile
      //   ? this.notification.warning(this.$lang("TEXT_WARNING_1"))
      //   : result && (this.recordUpdate(form), this.errorScoll());

      // this.$validator.validateAll("form1").then(validate => {
      //   Promise.all(promise_list).then(list => {
      //     var result = list.every(item => item);
      //     this.errorScoll();
      //     if (noChild) {
      //       if (form.isAgree1) {
      //         if (result) {
      //           this.recordUpdate(form);
      //           this.errorScoll();
      //         }
      //       } else {
      //         this.notification.warning(this.$lang("TEXT_WARNING_3"));
      //       }
      //     } else {
      //       if (!form.isAgree1 && !form.healthFile) {
      //         this.notification.warning(this.$lang("TEXT_WARNING_1"));
      //       } else {
      //         if (result) {
      //           this.recordUpdate(form);
      //           this.errorScoll();
      //         }
      //       }
      //     }
      //   });
      // });
    },
    async onSubmit2(evt) {
      evt.preventDefault();
      var form2 = {
        ...this.form2,
        status: this.status,
        teamMembers: this.form2.teamMembers.map((item, index) => {
          delete item["key"];
          delete item["index"];
          item.firstVaccination = this.$changeTime(item.firstVaccination) || "";
          item.secondVaccination =
            this.$changeTime(item.secondVaccination) || "";
          item.bornAt = this.$changeTime(item.bornAt) || "";
          return item;
        }),
      };
      if (this.form2.isChild == true) {
        form2.mixedChallenge = this.form2.teenager;
        form2.individual = false;
      } else {
        form2.mixedChallenge = this.form2.public;
      }
      if (this.status === "draft") {
        this.recordUpdate2(form2);
        this.errorScoll();
      } else {
        // var noChild = this.noChild(form2);
        // var bornAt = form2.bornAt;
        // var year = utils.getYear(bornAt);
        // var noChild = !(year > 2001 && year <= 2004);
        var bornAt = form2.teamMembers[0].bornAt;
        var year = utils.getYear(bornAt);
        var isAdult = year <= 2003;
        let result = await this.$refs["form2-item"].onSubmit();
        this.$validator.validateAll("form2").then((validate) => {
          // if (noChild) {
          //     if (form2.isAgree1 && form2.healthFile) {
          //         if (result) {
          //             this.recordUpdate2(form2);
          //             this.errorScoll();
          //         }
          //     } else {
          //         this.notification.warning(this.$lang("TEXT_WARNING_1"));
          //     }
          // } else {
          //     if (!form.isAgree1 && !form.healthFile) {
          //         this.notification.warning(this.$lang("TEXT_WARNING_1"));
          //     } else {
          //         if (result) {
          //             this.recordUpdate2(form2);
          //             this.errorScoll();
          //         }
          //     }
          // }

          // 未成年人必須作出聲明和上傳聲明書，成年人作出聲明或上傳聲明書
          if (isAdult) {
            if (form2.isAgree1 && this.isVaccination) {
              if (result) {
                this.recordUpdate2(form2);
                this.errorScoll();
              }
            } else {
              this.notification.warning(this.$lang("TEXT_WARNING_1"));
            }
          } else {
            if (form2.healthFile && this.isVaccination) {
              if (result) {
                this.recordUpdate2(form2);
                this.errorScoll();
              }
            } else {
              this.notification.warning(this.$lang("TEXT_WARNING_1"));
            }
          }

          // 不用判斷child
          // if(form2.isAgree1 && form2.healthFile) {
          //     if(result) {
          //         this.recordUpdate2(form2);
          //         this.errorScoll();
          //     }
          // }else {
          //     this.notification.warning(this.$lang("TEXT_WARNING_1"));
          // }
        });
      }
    },
    errorScoll() {
      let errEle = document.querySelector(".is-invalid");
      errEle ? this.animateScroll(errEle, 50) : "";
    },
    animateScroll(element, speed) {
      //获取元素相对窗口的top值，此处应加上窗口本身的偏移
      let top = window.pageYOffset + element.getBoundingClientRect().top;
      // 获取当前距离窗口的top值
      let osTop = document.documentElement.scrollTop || document.body.srcollTop;
      let requestId;
      let currentNumber = 0;
      //采用requestAnimationFrame，平滑动画
      function step() {
        if (osTop >= top) {
          currentNumber = osTop -= speed;
          window.scrollTo(0, osTop);
          requestId = window.requestAnimationFrame(step);
        } else {
          window.cancelAnimationFrame(requestId);
        }
      }
      window.requestAnimationFrame(step);
    },
    noChild(form) {
      let noChild = true;
      let teamMembers = form.teamMembers;
      teamMembers.forEach((item, index) => {
        const bornAt = item.bornAt;
        const year = utils.getYear(bornAt);
        if (year > 2001 && year <= 2004) {
          noChild = false;
        }
      });
      return noChild;
    },
    handleRemove(item) {
      if (this.form.teamMembers.length <= 4) {
        return;
      }
      var index = this.form.teamMembers.indexOf(item);
      if (index !== -1) {
        this.form.teamMembers.splice(index, 1);
      }
    },
    handleAdd() {
      this.index++;
      this.form.teamMembers.push({
        index: this.index,
        lastName: null,
        firstName: null,
        gender: null,
        bornAt: "",
        idType: 1,
        idNumber: null,
        firstVaccination: "",
        secondVaccination: "",
      });
    },
    uploadMembers(list) {
      return list.map((item, index) => {
        delete item["key"];
        delete item["index"];
        item.bornAt = this.$changeTime(item.bornAt) || "";
        item.firstVaccination = this.$changeTime(item.firstVaccination) || "";
        item.secondVaccination = this.$changeTime(item.secondVaccination) || "";
        return item;
      });
    },
    recordUpdate(form) {
      if (this.status == "draft") {
        this.saveForm(form)
          .then((resp) => {
            let type = this.mode;
            if (type == "edit") {
              this.notification.success(this.$lang("TITLE_CHANGE_SUCCESS"));
            } else {
              this.notification.success(this.$lang("TITLE_SAVE_SUCCESS"));
            }
            this.$router.push({
              name: "physical-challenge",
            });
          })
          .catch((err) => {
            console.log(err);
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form-item"][index].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              if (err.data.length == 0) {
                this.notification.error(this.$lang(err.message));
              }
              var errs = err.data.teamMembers;
              var that = this;
              Object.keys(errs).forEach(function (key) {
                that.notification.error(that.$lang(errs[key].message));
              });
            }
          })
          .finally(() => {
            this.errorScoll();
          });
      } else {
        this.recordPro(form)
          .then((resp) => {
            // let type = this.mode;
            // if (type == "edit") {
            //     this.notification.success(this.$lang("提交成功"));
            // } else {
            //     this.notification.success(this.$lang("提交成功"));
            // }
            this.notification.success(this.$lang("提交成功"));
            this.$router.push({
              name: "physical-challenge",
            });
          })
          .catch((err) => {
            console.log(err);
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form-item"][index].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              console.log(err.data.length == 0);
              if (err.data.length == 0) {
                this.notification.error(this.$lang(err.message));
              }
              var teamMembers = err.data.teamMembers
                ? err.data.teamMembers
                : "";
              var that = this;
              if (teamMembers) {
                Object.keys(teamMembers).forEach(function (key) {
                  that.$refs["form-item"][key].validateErrors(
                    teamMembers[key].path,
                    that.$lang(teamMembers[key].message)
                  );
                  that.notification.error(that.$lang(teamMembers[key].message));
                });
              } else {
                this.notification.error(this.$lang(err.data));
              }
              // var errs = err.data.teamMembers;
              // var that = this;
              // Object.keys(errs).forEach(function (key) {
              //     that.notification.error(that.$lang(errs[key].message));
              // });
            }
          })
          .finally(() => {
            this.errorScoll();
          });
      }
    },
    recordUpdate2(form) {
      if (this.status == "draft") {
        this.saveForm(form)
          .then((resp) => {
            let type = this.mode;
            if (type == "edit") {
              this.notification.success(this.$lang("TITLE_CHANGE_SUCCESS"));
            } else {
              this.notification.success(this.$lang("TITLE_SAVE_SUCCESS"));
            }
            this.$router.push({
              name: "physical-challenge",
            });
          })
          .catch((err) => {
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form2-item"].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              var errs = err.data;
              this.notification.error(this.$lang(err.message));
            }
          });
      } else {
        this.recordPro(form)
          .then((resp) => {
            // let type = this.mode;
            // if (type == "edit") {
            //     this.notification.success(this.$lang("TITLE_CHANGE_SUCCESS"));
            // } else {
            //     this.notification.success(this.$lang("新增成功"));
            // }
            this.notification.success(this.$lang("提交成功"));
            this.$router.push({
              name: "physical-challenge",
            });
          })
          .catch((err) => {
            if (err.data.teamMembers instanceof Array) {
              err.data.teamMembers.forEach((item, index) => {
                this.$refs["form2-item"].validateErrors(
                  item.path,
                  this.$lang(item.message)
                );
                this.notification.error(this.$lang(item.message));
              });
            } else {
              var errs = err.data;
              this.notification.error(this.$lang(errs.groupType.message));
            }
          });
      }
    },
    async recordPro(form) {
      // 防止連續點擊重複提交
      this.isDisable = true;
      setTimeout(() => {
        this.isDisable = false; //点击一次时隔两秒后才能再次点击
      }, 2000);
      return new Promise((resolve, reject) => {
        $apis.dynamic
          .recordUpdate(form)
          .then((resp) => {
            if (resp.code === 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // save
    async saveForm(form) {
      // 防止連續點擊重複提交
      this.isDisable = true;
      setTimeout(() => {
        this.isDisable = false; //点击一次时隔两秒后才能再次点击
      }, 2000);
      return new Promise((resolve, reject) => {
        $apis.dynamic
          .saveForm(form)
          .then((resp) => {
            if (resp.code === 0) {
              resolve(resp);
            } else {
              reject(resp);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async recordDetail(id) {
      if (this.mode === "perview") {
        this.loading = true;
        let resp = await $apis.dynamic.recordDetail({
          id,
        });
        this.loading = false;
        var groupType = resp.data.groupType;
        if (groupType == "individual") {
          this.form2 = resp.data;
          this.handelShow();
          this.isType = "individual";
        } else {
          this.form = resp.data;
          this.isType = "team";
        }
      } else {
        this.loading = true;
        let resp = await $apis.dynamic.loadForm({ id });
        this.loading = false;
        var groupType = resp.data.groupType;
        if (groupType == "individual") {
          this.form2 = resp.data;
          this.isType = "individual";
        } else {
          this.form = resp.data;
          this.isType = "team";
        }
      }
    },
    getUserInfo() {
      this.loading = true;
      $apis.user
        .getUserInfo()
        .then((resp) => {
          var data = resp.data;
          if (this.is_group === "team") {
            // this.form.teamMembers[0] = {
            //     lastName: data.lastNameZh || data.lastNamePt,
            //     firstName: data.firstNameZh || data.firstNamePt,
            //     bornAt: data.bornAt,
            //     gender: data.gender,
            //     idType: data.idType,
            //     idNumber: data.idNumber,
            //     email: null,
            //     phone: null
            // };
            (this.form.teamMembers[0].lastName =
              data.lastNameZh || data.lastNamePt),
              (this.form.teamMembers[0].firstName =
                data.firstNameZh || data.firstNamePt),
              (this.form.teamMembers[0].bornAt = data.bornAt);
            this.form.teamMembers[0].gender = data.gender;
            this.form.teamMembers[0].idType = data.idType;
            this.form.teamMembers[0].idNumber = data.idNumber;
            this.form.teamMembers[0].phone = "";
          } else {
            // this.form2.teamMembers[0] = {
            //     lastName: data.lastNameZh || data.lastNamePt,
            //     firstName: data.firstNameZh || data.firstNamePt,
            //     bornAt: data.bornAt,
            //     gender: data.gender,
            //     idType: data.idType,
            //     idNumber: data.idNumber,
            //     email: null,
            //     phone: null
            // };
            (this.form2.teamMembers[0].lastName =
              data.lastNameZh || data.lastNamePt),
              (this.form2.teamMembers[0].firstName =
                data.firstNameZh || data.firstNamePt),
              (this.form2.teamMembers[0].bornAt = data.bornAt);
            this.form2.teamMembers[0].gender = data.gender;
            this.form2.teamMembers[0].idType = data.idType;
            this.form2.teamMembers[0].idNumber = data.idNumber;
            this.form2.teamMembers[0].phone = "";
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    selectedChange() {
      this.$validator.reset();
    },
    getGrouping(flag) {
      this.form2.isChild = flag;
      if (this.form2.isChild == true) {
        this.form2.individual = false;
      }
    },
    //个人
    getGroupings(flag) {
      if (flag) {
        this.ispersion = false;
      } else {
        this.ispersion = true;
      }
    },
    //是否18歲顯示健康聲名
    isAdultNew(flag) {
      if (flag) {
        this.isAdultnew = true;
      } else {
        this.isAdultnew = false;
      }
    },
    // 處理perview時混合體能挑戰賽的顯示與隱藏
    handelShow() {
      if (this.form2.isChild == false) {
        this.form2.public = this.form2.mixedChallenge;
      } else {
        this.form2.teenager = this.form2.mixedChallenge;
      }
    },
  },
  computed: {
    // 判斷個人/團隊報名
    is_group() {
      return this.$route.query.type;
    },
    disabled() {
      return this.mode === "perview" || this.mode === "edit";
    },
    is_perview() {
      return this.mode === "perview";
    },
    is_edit() {
      return this.mode === "edit";
    },
    is_new() {
      return this.mode === "new";
    },
    downPdf() {
      return this.$store.getters["base/dynamicHealthFileExample"];
    },
    link() {
      return this.$store.getters["base/baseUrl"];
    },
    url() {
      return this.link + this.downPdf;
    },
  },
  created() {
    var id = this.$route.params.slug;
    var isNew = this.is_new;
    this.form.id = id;
    this.form2.id = id;
    id && this.recordDetail(id);
    isNew && this.getUserInfo();
  },
};
</script>
